import * as Yup from 'yup';
import dayjs from 'dayjs';

const posNumber = /^[0-9 ]+$/;

export const submitPaymentValidationSchema = (props: any) =>
  Yup.object().shape({
    firstName: Yup.string()
      .required('Please enter a valid first name.')
      .matches(/^[a-zA-Z\-`', ]*$/, 'No numbers or special characters')
      .max(20, 'Name should not be more than 20'),
    lastName: Yup.string()
      .required('Please enter a valid last name.')
      .matches(/^[a-zA-Z\-`', ]*$/, 'No numbers or special characters')
      .max(20, 'Name should not be more than 20'),
    address1: Yup.string()
      .matches(/^[a-zA-Z0-9\- .@#()]*$/, 'No special characters')
      .max(25, 'Address should not be more than 25')
      .required('Please enter a valid address'),
    address2: Yup.string()
      .matches(/^[a-zA-Z0-9\- .@#()]*$/, 'No special characters')
      .max(25, 'Address should not be more than 25')
      .notRequired(),
    city: Yup.string()
      .matches(/^[a-zA-Z\-. ]*$/, 'No numbers or special characters')
      .max(20, 'City should not be more than 20')
      .required('Please enter a valid city'),
    state: Yup.string().required('Please enter a valid state.'),
    zipCode: Yup.string()
      .matches(/^[0-9]{5}$/, 'Please enter a valid zip code (XXXXX)')
      .required('Please enter a valid zip code'),
    accountType: Yup.number()
      .notRequired()
      .when('paymentMethod', {
        is: val => val === '2',
        then: Yup.number().required('Please enter a valid account type.')
      }),
    routingNumber: Yup.number()
      .typeError('You must specify a number')
      .notRequired()
      .when('paymentMethod', {
        is: val => val === '2',
        then: Yup.number().required('Please enter a valid routing number.')
      }),
    accountNumber: Yup.number()
      .typeError('You must specify a number')
      .notRequired()
      .when('paymentMethod', {
        is: val => val === '2',
        then: Yup.number().required('Please enter a valid account number.')
      }),
    cardNumber: Yup.string()
      .typeError('You must specify a number')
      .notRequired()
      .when('paymentMethod', {
        is: val => val === '1',
        then: Yup.string()
          .matches(posNumber, 'Card should be valid number')
          .min(12, 'Card number should be more than 12 digits')
          .required('Please enter a valid Card number.')
      }),
    cardExpiration: Yup.string()
      .notRequired()
      .when('paymentMethod', {
        is: val => val === '1',
        then: Yup.string()
          .matches(
            /^(0[1-9]|1[0-2])\/?(([0-9]{4}|[0-9]{2})$)/,
            'Please enter a valid expiration date MM/YY'
          )
          .required('Please enter a valid expiration date MM/YY.')
          .test('Expiration Date', 'Should be valid expiration date', typedNumber => {
            if (typedNumber && typedNumber.length === 5) {
              const enteredDate = dayjs(
                `20${typedNumber.split('/')[1]}-${typedNumber.split('/')[0]}-01`
              );
              const today = dayjs(new Date());
              if (enteredDate.isBefore(today)) {
                return false;
              }
            }
            return true;
          })
      }),
    cardCvv: Yup.string()
      .notRequired()
      .when('paymentMethod', {
        is: val => val === '1',
        then: Yup.string()
          .matches(/^[0-9]{3,4}$/, 'Please enter a valid CVV code')
          .required('Please enter a valid CVV code.')
      }),
    emailAddress: Yup.string()
      .email('Please enter a valid email address')
      .required('Please enter a valid email address')
  });
